export default __webpack_public_path__ + "static/media/placeholder11.6446c33e.jpg";